import { useEffect, useState } from "react";

const navs = [
  { id: "live", label: "现场直击" },
  { id: "events", label: "热门事件" },
  { id: "themes", label: "主题图集" },
  { id: "gallery", label: "高清生图" },
  { id: "collections", label: "精选合集" },
  { id: "about", label: "关于图集" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id: string) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setSearchOpen(false);
    if (keyword.trim()) {
      document.getElementById("gallery")?.scrollIntoView({ behavior: "smooth" });
      window.dispatchEvent(new CustomEvent("chigua:search", { detail: keyword.trim() }));
      setKeyword("");
    }
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* brand */}
          <a
            href="#top"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="flex items-center gap-2.5 group"
          >
            <span className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-camera-lens-fill text-lg md:text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="text-lg md:text-xl font-heading font-bold text-foreground-950 tracking-tight">
                吃瓜图集
              </span>
              <span className="mt-1 text-[10px] md:text-[11px] font-medium text-foreground-500 tracking-[0.2em]">
                现场生图 · 一网打尽
              </span>
            </span>
          </a>

          {/* desktop nav */}
          <nav className="hidden lg:flex items-center gap-1">
            {navs.map((n) => (
              <button
                key={n.id}
                onClick={() => go(n.id)}
                className="px-3.5 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-500/10 transition whitespace-nowrap cursor-pointer"
              >
                {n.label}
              </button>
            ))}
          </nav>

          {/* right actions */}
          <div className="flex items-center gap-2 md:gap-3">
            <div
              className={`hidden sm:flex items-center transition-all duration-300 overflow-hidden ${
                searchOpen ? "w-56 md:w-64" : "w-9"
              }`}
            >
              <form onSubmit={submitSearch} className="flex items-center w-full">
                {searchOpen && (
                  <input
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    autoFocus
                    placeholder="搜事件 / 现场 / 人物"
                    className="flex-1 min-w-0 h-9 px-3 text-sm rounded-l-md border border-background-300 border-r-0 outline-none bg-background-50 focus:border-primary-400"
                  />
                )}
                <button
                  type="button"
                  onClick={() => {
                    if (searchOpen && keyword.trim()) submitSearch({ preventDefault: () => {} } as React.FormEvent);
                    else setSearchOpen((v) => !v);
                  }}
                  aria-label="搜索"
                  className="shrink-0 h-9 w-9 flex items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:text-primary-600 hover:border-primary-400 bg-background-50/60 transition cursor-pointer"
                >
                  <i className="ri-search-line"></i>
                </button>
              </form>
            </div>

            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                go("contact");
              }}
              className="hidden md:inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition whitespace-nowrap cursor-pointer"
            >
              <i className="ri-focus-2-line"></i>
              投稿线索
            </a>

            <button
              onClick={() => setOpen((v) => !v)}
              aria-label="菜单"
              className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 hover:text-primary-600 cursor-pointer"
            >
              <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
            </button>
          </div>
        </div>
      </div>

      {/* mobile menu */}
      {open && (
        <nav className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-3 space-y-1 shadow-lg">
          {navs.map((n) => (
            <button
              key={n.id}
              onClick={() => go(n.id)}
              className="flex items-center justify-between w-full px-3 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:bg-primary-500/10 cursor-pointer"
            >
              {n.label}
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
            </button>
          ))}
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              go("contact");
            }}
            className="flex items-center justify-center gap-1.5 mt-2 h-10 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
          >
            <i className="ri-focus-2-line"></i>
            投稿线索
          </a>
        </nav>
      )}
    </header>
  );
}